import React from 'react';
import { useSelector } from 'react-redux';
import { alertEventSelector, hasManualAlertSelector } from '@store/trends/alerts/selectors';
import AlertInfo from './AlertInfo';
import AlertTable from './AlertTable';
import { isEmpty } from 'lodash';
import HeatMap from './HeatMap';
import { PanelRow } from '../styled';


function ManualAlert() {
  const event = useSelector(alertEventSelector);
  const hasManualAlert = useSelector(hasManualAlertSelector);

  if(!hasManualAlert || isEmpty(event)) {
    return null;
  }

  const { id, alertId } = event;

  return (
    <PanelRow>
      <div>
        <AlertInfo eventId={id} />
      </div>
      <div>
        <AlertTable alertId={alertId} activeEventId={id} />
      </div>
      <div>
        <HeatMap alertId={alertId} />
      </div>
    </PanelRow>
  );
}


export default ManualAlert;
